module.exports = require('./SelectPageCell');
